import {graphql} from 'gatsby'
import React from 'react'

import type {JobsGridSliceFragment} from '@/graphql-types'
import {JobsGrid} from '@/sections/jobs-grid'

type Props = {
    slice: JobsGridSliceFragment
}

export const JobsGridSlice = ({slice}: Props) => {
    const {headline, text, cta_text} = slice.primary

    return <JobsGrid headline={headline} text={text} ctaText={cta_text} />
}

export const jobsGridSliceFragment = graphql`
    fragment JobsGridSlice on PrismicSlicePageDataBodyJobsGrid {
        __typename
        primary {
            headline
            text
            cta_text
        }
    }
`
